<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="fill-none" viewBox="0 0 13 9">
    <path d="M1 1.25L6.5 6.75L12 1.25" stroke-width="2" />
  </svg>
</template>
